import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import classes from "./Skeleton.module.css"

const SkeletonLoader = () => {
    
  return (
    <SkeletonTheme baseColor="#F2F2F2" highlightColor="#ffffff">
      <div className={classes.skeletonContainer}>
        {/* <Skeleton count={5} height={30} /> */}
        <div className={classes.skeletonRow}>
          <Skeleton width={120} height={30} />
        </div>
        <div className={classes.skeletonRow}>
          <Skeleton width={120} height={30} />
        </div>
        <div className={classes.skeletonRow}>
          <Skeleton width={120} height={30} />
        </div>
        <div className={classes.skeletonRow}>
          <Skeleton width={120} height={30} />
        </div>
        <div className={classes.skeletonRow}>
          <Skeleton width={120} height={30} />
        </div>
        <div className={classes.skeletonRow}>
          <Skeleton width={120} height={30} />
        </div>
        <div className={classes.skeletonRow}>
          <Skeleton width={120} height={30} />
        </div>
        <div className={classes.skeletonRow}>
          <Skeleton width={120} height={30} />
        </div>
        <div className={classes.skeletonRow}>
          <Skeleton width={120} height={30} />
        </div>
        <div className={classes.skeletonRow}>
          <Skeleton width={120} height={30} />
        </div>
        <div className={classes.skeletonRow}>
          <Skeleton width={120} height={30} />
        </div>
        <div className={classes.skeletonRow}>
          <Skeleton width={120} height={30} />
        </div>
        <div className={classes.skeletonRow}>
          <Skeleton width={120} height={30} />
        </div>
      </div>
    </SkeletonTheme>
  );
  
}

export default SkeletonLoader



